import React from 'react'
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import FormSelect from "../../components/atoms/Select";
import {
    agregarStringAArraydDeStringsSiNoExiste,
    eliminarStringDeArraydDeStrings,
    handleFind,
    stringSeEncuentraEnArray
} from "../../helper/utils";
import PageTable from "../../components/pageComponents/PageTable";
import ActionsIcons from "../../components/atoms/ActionsIcons";
import { desBloquearEmpleadoDocumentoPagoAPI } from '../../consumers/backendApisUrls';

const TableDocumentoPago = ({
                         formValues,
                         setFormValues,
                         extraData,
                         setModalEnabled,
                         paginator,
                         setPaginator,
                         keys: KEYS,
                         idsDocumentosConCheck,
                         setIdsDocumentosConCheck,
                         manageSearch,
                         fromAdminPage,
                         bloquearEmpleadoDocumento,
                         desBloquearEmpleadoDocumento,
                         toggleObservarRegistroModal,
                         toggleDescargarDocumentoPagoModal
                     }) => {
    const rows = formValues.Items;
    const HEADERS = [
        {col: "col-sm-1", label: "Fecha de Registro"},
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsTipoDocumentosPago)}
                        description="Tipo Documento"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsTipoDocumentosPago] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsTipoDocumentosPago)}
                    />
                </div>
        },
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsAnios)}
                    description="Año"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsAnios] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsAnios)}
                />
            </div>            
        },
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsPeriodos)}
                    description="Periodo"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsPeriodos] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsPeriodos)}
                />
            </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsEstados)}
                        description="Estado Doc."
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstados] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstados)}
                    />
                </div>
        },
        {col: "col-sm-1", label: "Nro. Operación"},
        {col: "col-sm-2", label: "Nombre"},
        {col: "col-sm-1", label: "Fec. Ingreso"},
        {col: "col-sm-1", label: 
            <div className='d-flex justify-content-center'>
                <FormSelect
                    options={handleFind(formValues.filters, KEYS.IdsEstadosEmpleado)}
                    description="Estado Empleado"
                    selectedOptions={formValues.selectedFilters?.[KEYS.IdsEstadosEmpleado] ?? []}
                    setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsEstadosEmpleado)}
                />
            </div>
        },
        {
            col: "col-sm-1", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsCargos)}
                        description="Cargo"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsCargos] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsCargos)}
                    />
                </div>
        },
        {
            col: "col-sm-2", label:
                <div className='d-flex justify-content-center'>
                    <FormSelect
                        options={handleFind(formValues.filters, KEYS.IdsSedes)}
                        description="Sede"
                        selectedOptions={formValues.selectedFilters?.[KEYS.IdsSedes] ?? []}
                        setSelectedOptions={(res) => handleFilterSelected(res, KEYS.IdsSedes)}
                    />
                </div>
        },
        {col: "", label: "Acciones"},
    ]

    const handleFilterSelected = (res, key) => {
        const updatedSelectedFilters = {...formValues.selectedFilters, [key]: res};
        setFormValues(lastData => ({...lastData, selectedFilters: updatedSelectedFilters}));
    }

    return (
        <PageTable headers={HEADERS} paginator={paginator} setPaginator={setPaginator}>
            <tbody className="listar-tbody">
                {rows.map((row) => (
                    <tr key={row.IdEmpleadoDocumentoPago}>
                        <td className="text-center">{row.FechaRegistro}</td>
                        <td className="text-center">{row.TipoDocumentoPago}</td>
                        <td className="text-center">{row.Anio}</td>
                        <td className="text-center">{row.NombrePeriodo}</td>
                        <td className="text-center">{row.EstadoProceso}</td>
                        <td className="text-center">{row.NumeroOperacion}</td>
                        <td className="text-center">{row.NombreEmpleado}</td>
                        <td className="text-center">{row.FechaIngreso}</td>
                        <td className="text-center">{row.EstadoEmpleado}</td>
                        <td className="text-center">{row.Cargo}</td>
                        <td className="text-center">{row.Sede}</td>
                        <td className="text-center">
                            <ActionsIcons>
                                <div className="d-flex justify-content-start">                                
                                    <div>
                                        <FontAwesomeIcon icon='download' 
                                            className="hand-pointer blue-standard-color"                                            
                                            title="Descargar" 
                                            onClick={() => toggleDescargarDocumentoPagoModal(row?.IdEmpleadoDocumentoPago)}
                                            />
                                    </div>                                    

                                    {(row?.PuedeDesbloquear === true && fromAdminPage) &&
                                        <div>
                                            <FontAwesomeIcon icon='lock-open' size="sm" className="hand-pointer ml-3" title="Desbloquear" color="#808080"
                                            onClick={() => desBloquearEmpleadoDocumento(row?.IdEmpleadoDocumentoPago)}/>
                                        </div>
                                    }

                                    {(row?.PuedeBloquear === true && fromAdminPage) &&
                                        <div>
                                            <FontAwesomeIcon icon='lock' size="sm" className="hand-pointer ml-3" title="Bloquear" 
                                            onClick={() => bloquearEmpleadoDocumento(row?.IdEmpleadoDocumentoPago)} />
                                        </div>
                                    }

                                    {(row?.PuedeObservar === true && !row?.IsBlocked && fromAdminPage) &&
                                    <div>
                                        <FontAwesomeIcon icon='exclamation-triangle' size="sm" className="hand-pointer ml-3" title="Observar" 
                                        onClick={() => toggleObservarRegistroModal(row?.IdEmpleadoDocumentoPago)}/>
                                    </div>
                                    }
                                                                                                            
                                   
                                </div>                                
                                {/* {(fromAdminPage) &&
                                <div className="d-flex justify-content-start">                                    
                                    <button className="btn btn-primary generic-button-ficha pt-0 pb-0 ml-0 " onClick="">
                                        Aprobar
                                    </button>
                                </div>
                                } */}
                            </ActionsIcons>
                        </td>
                    </tr>
                ))}
            </tbody>
        </PageTable>
    );
}

export default TableDocumentoPago;